export const campaignTypeLabels = {
  visitation: 'Foot Traffic/Retail Sales Attribution',
  cpg: 'CPG',
  rsl: 'RSL',
  rslvisits: 'RSL + Visitation',
  all: 'All',
};

export type CampaignType = keyof typeof campaignTypeLabels;
